export default __webpack_public_path__ + "static/media/person.dffeffe0.svg";